<div class="home-block light" id="exhibitors">
  <div class="home-container">
    <h1>Kiállítók és Partnerek 2026</h1>
    <div
      class="embla"
      emblaCarousel
      id="embla-exhibitors"
      [options]="{ loop: true }"
      [plugins]="plugins"
    >
      <div class="embla__container carousel-track">
        @if (isLoading()) {
          <mat-spinner class="mx-auto" strokeWidth="12" />
        } @else {
          @for (p of partners; track p) {
            <div class="embla__slide">
              @if (p.website) {
                <a target="_blank" [href]="p.website">
                  <img
                    height="100"
                    loading="lazy"
                    width="200"
                    [alt]="p.alt"
                    [src]="p.file | fileToUrl"
                  />
                </a>
              } @else {
                <span>
                  <img
                    height="100"
                    loading="lazy"
                    width="200"
                    [alt]="p.alt"
                    [src]="p.file | fileToUrl"
                  />
                </span>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
<div class="home-block" id="exhibitor-divider">
  <img
    alt=""
    height="265"
    loading="lazy"
    src="/multimedia/home/exhibitors-divider.webp"
    width="1240"
  />
</div>
